import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { ExecutionDetailPage } from '@/components/MarketingRules/ExecutionDetailPage'
import {
  executionSearchSchema,
  withoutExecutionSearchDefaults,
  type ExecutionSearch,
} from '@/components/MarketingRules/search'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/marketing/rules-v2/executions/$executionId')({
  validateSearch: executionSearchSchema,
  component: ExecutionRoute,
})

function ExecutionRoute() {
  const { executionId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  // Stable, because the page's debounced search waits on it: a new function
  // every render would restart the timer on every keystroke's re-render.
  const onSearchChange = useCallback(
    (next: Partial<ExecutionSearch>) =>
      void navigate({
        search: (current) => withoutExecutionSearchDefaults({ ...current, ...next }),
        replace: true,
      }),
    [navigate],
  )

  return (
    <ExecutionDetailPage
      executionId={executionId}
      search={search}
      onSearchChange={onSearchChange}
    />
  )
}
